// WaterLog v0 PRD §3/§5: ships behind a Crew Mode feature flag that stays
// off for every pilot farm until real operator attribution (Charter D-4,
// the PIN mechanism) is wired in. Flag granularity (per-tenant vs per-farm
// vs per-operator) is an explicit PRD non-goal — this is the minimum
// viable per-farm toggle, flipped manually per farm during pilot setup,
// not a self-serve admin UI (that is future scope if the pilot needs it).

import { getActiveTenantKey, getTenantScopedKey } from '../../offline/tenant'

const FLAG_BASE_KEY = 'crewModeWaterLogEnabledFarms'

const hasStorage = (): boolean => typeof globalThis !== 'undefined' && Boolean(globalThis.window?.localStorage)

const readEnabledFarmIds = (tenantKey: string): Set<string> => {
  if (!hasStorage()) return new Set()
  try {
    const raw = globalThis.window?.localStorage?.getItem(getTenantScopedKey(FLAG_BASE_KEY, tenantKey))
    if (!raw) return new Set()
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? new Set(parsed.filter((value): value is string => typeof value === 'string')) : new Set()
  } catch {
    return new Set()
  }
}

const writeEnabledFarmIds = (tenantKey: string, farmIds: Set<string>): void => {
  if (!hasStorage()) return
  try {
    globalThis.window?.localStorage?.setItem(
      getTenantScopedKey(FLAG_BASE_KEY, tenantKey),
      JSON.stringify(Array.from(farmIds))
    )
  } catch {
    // ignore
  }
}

export const isWaterLogCrewModeEnabled = (farmId: string, tenantKey = getActiveTenantKey()): boolean => {
  if (!farmId) return false
  return readEnabledFarmIds(tenantKey).has(farmId)
}

export const setWaterLogCrewModeEnabled = (
  farmId: string,
  enabled: boolean,
  tenantKey = getActiveTenantKey()
): void => {
  if (!farmId) return
  const enabledFarmIds = readEnabledFarmIds(tenantKey)
  if (enabled) {
    enabledFarmIds.add(farmId)
  } else {
    enabledFarmIds.delete(farmId)
  }
  writeEnabledFarmIds(tenantKey, enabledFarmIds)
}
